import { array, boolean, number, object, string } from "yup";

export const updateNoteSchema = object({
  description: string().min(1).required(""),
});

export const createNonChatTicketSchema = object({
  ticket_title: string().min(1).required("Title required"),
  company_group_id: string().required("Company group required"),

  group_entity_id: string().when("isNonChatTicket", {
    is: true,
    then: (schema) => schema.required("Group entity required"),
    otherwise: (schema) => schema.optional(),
  }),

  is_priced_ticket: string().required("Ticket type required"),

  price: number().when("is_priced_ticket", {
    is: "PRICED_TICKETS",
    then: (schema) =>
      schema.required().min(1, "Ticket price cannot be set to zero"),
    otherwise: (schema) => schema.optional(),
  }),

  assignees: array().min(1).required("Assignees required"),
  createChatChannel: boolean().notRequired(),

  channelName: string().when("createChatChannel", {
    is: true,
    then: string().required("Channel name required"),
    otherwise: string().notRequired(),
  }),

  estimatedDeliveryTime: string().when("canNotDeclare", {
    is: false,
    then: (schema) => schema.required("Estimated delivery time is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  reminderDate: string().when("canNotDeclare", {
    is: true,
    then: (schema) => schema.required("Reminder date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  canNotDeclare: boolean().required(),
  customDate: string().when("reminderDate", {
    is: "CUSTOM",
    then: (schema) => schema.required("Custom date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  description: string().when("isInternalTicket", {
    is: true,
    then: (schema) => schema.min(1).required("Description required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export const resolutionDescriptionSchema = object({
  description: string().min(1).required("Description required"),
});

export const ticketPriceSchema = object({
  ticket_price: number()
    .moreThan(0, "Ticket price cannot be set to zero")
    .required("Invalid price"),
  ticket_title: string().min(1).required("Title required"),
});

export const ticketETDUpdateSchema = object({
  estimatedDeliveryTime: string().required(
    "Estimated delivery time is required"
  ),
  reason: string().required("Reason is required"),
  message: string().required("Message is required"),
});

// Reason is optional when setting the ETD for the first time (no prior ETD to revise)
export const etdSetSchema = ticketETDUpdateSchema.shape({
  reason: string().notRequired(),
});

// Internal tickets don't send a customer-facing message, so it isn't required
export const internalTicketETDUpdateSchema = ticketETDUpdateSchema.shape({
  message: string().notRequired(),
});

export const addTicketETDSchema = object({
  estimated_delivery_time: string().required(
    "Estimated delivery time is required"
  ),
});
